import { toast } from 'sonner';

export async function copyToClipboard(text: string, label = 'Copiado') {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(label);
  } catch {
    toast.error('No pudimos copiar. Seleccioná el texto y copialo a mano.');
  }
}
